import { VoucherStatus, type Voucher } from '@src/domains/vouchers/types/voucher';

export function isVoucherPending(voucher: Voucher): boolean {
  return voucher.status === VoucherStatus.Pending;
}
